/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFloppyPen: {
  name: 'floppy-pen';
  data: string;
} = {
  name: 'floppy-pen',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3-1.5 1.5a1 1 0 0 1-.566.283l-3.5.5a1 1 0 0 1-1.13-1.131l.5-3.5a1 1 0 0 1 .282-.566l1.5-1.5 3-3ZM14 8.414l-.557.557-.264 1.85 1.85-.264.557-.557L14 8.414Zm3 .172L15.414 7 17 5.414 18.586 7 17 8.586ZM3 5a2 2 0 0 1 2-2h6a1 1 0 1 1 0 2h-1v2a1 1 0 0 1-2 0V5H5v14h3v-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2h3v-6a1 1 0 1 1 2 0v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm11 14v-2h-4v2h4Z" fill="currentColor"/></svg>`,
};
